export const Icons = {
  logoText: require("./drx-token-text.png"),
  logoGK: require("./gk-logo.png"),
};
